import { Application } from '../../../../../types/api';
import loanFormModel from '../../components/loan_application/form_models/loanFormModel';
import { defaultApplicantName } from '../../constants';
import { ValidationSchema } from '../interfaces';
import FileNameValidationSchema from '../FileNameValidationSchema';
import { Validation } from '../Validation';
import { isPropertyCompany, isCoreOrExpressPlusLoan } from './helpers';

const {
  companyDocuments: { propertyCompanyRentRoll },
  systemPowerCompanyType,
  loanCategory,
  propertyCompanyUploadRentRollOrProvideTenantInfo,
} = loanFormModel.formField;

export class PropertyCompanyRentRollValidation implements ValidationSchema {
  public name = propertyCompanyRentRoll.name;
  public label = propertyCompanyRentRoll.getLabel(defaultApplicantName);
  public dependsOn: string[] = [
    systemPowerCompanyType.name,
    propertyCompanyUploadRentRollOrProvideTenantInfo.name,
    loanCategory.name,
  ];
  public type = 'string';
  public required = {
    message: '',
    value: false,
  };

  public when(
    systemPowerCompanyType: Application['solar_system_power_company_type'],
    propertyCompanyUploadRentRollOrProvideTenantInfo: Application['system_power_rent_roll_or_tenant_info'],
    loanCategory: Application['loan_category'],
    schema
  ) {
    const required =
      isPropertyCompany(systemPowerCompanyType) &&
      propertyCompanyUploadRentRollOrProvideTenantInfo === 'Upload rent roll' &&
      isCoreOrExpressPlusLoan(loanCategory);
    schema = FileNameValidationSchema(propertyCompanyRentRoll.name, required);
    if (required) schema = schema.required('This document is required');
    return schema;
  }
}
export default new Validation(new PropertyCompanyRentRollValidation());
